import React from "react";
import { Loader, Box } from "@flexisaf/flexibull2";
import Theme from "../../theme";
const SectionLoader = ({
  width = "100%",
  height = "100vh",
  color = Theme.PrimaryColor,
}) => {
  return (
    <Box width={width} height={height}>
      <Loader section={true} color={color} />
    </Box>
  );
};
export default SectionLoader;
